import { Client } from 'types/api/attacks/client'
import { TargetingStrategy } from 'types/api/attacks/details/targeting'
import { AwsLoadBalancerResponse } from 'types/api/aws/metadata'
import { UserDefinedServiceJiraDefaults } from 'types/api/jira/user-defined-jira-defaults'
import { K8sClient } from 'types/api/kubernetes/kubernetes'
import { LoadGenerator } from 'types/api/services/load-generator'
import {
  ScheduleSettings,
  ScheduleTriggerType
} from 'types/schedules/schedules'

export type ServiceIgnoreReason = 'UNIMPORTANT' | 'UNRECOGNIZED' | 'INCORRECT'

export interface ServiceIgnoredInfo {
  reason: ServiceIgnoreReason
  detail?: string
}

export interface ServiceActiveTargets {
  clients: Client[]
  k8sClients: K8sClient[]
}

export interface SchedulableTest {
  reliabilityTestId: string
  dependencyId?: string
  status: ScheduleTriggerType
}

export interface ServiceOwner {
  firstName?: string
  lastName?: string
  identifier: string
}

export enum EvaluationState {
  NoDeploymentFound = 'NO_DEPLOYMENT_FOUND',
  Evaluated = 'EVALUATED',
  RisksNotIncluded = 'RISKS_NOT_INCLUDED' // set when a service's test suite excludes all evaluate-able risks
}

export interface RiskSummaryStats {
  total: number
  atRisk: number
  evaluationState: EvaluationState
}

export interface MultiSelectTags {
  [key: string]: string[]
}

// TODO: Rename this to Service when we refactor the existing `Service`
export interface UserDefinedService {
  teamId: string
  serviceId: string
  targetingStrategy: TargetingStrategy
  processSignature?: string
  processName?: string
  processId?: string
  name: string
  description?: string | null
  awsTargets: AwsLoadBalancerResponse[]
  eligibleForGremlinAwsStatusCheck: boolean
  enabledGremlinAwsStatusCheck: boolean
  createdAt: Date | string
  updatedAt: Date | string // the date/time of any change to the service
  statusCheckIds?: string[]
  scheduleSettings?: ScheduleSettings
  schedulableTests: SchedulableTest[]
  autoCreatingJiraTicketsEnabled: boolean
  defaultJiraIssueFields: UserDefinedServiceJiraDefaults
  modifiedDate: string // the date/time of any user-initiated change to the service
  loadGenerators?: LoadGenerator[]
  tags: {
    environment?: string
    [key: string]: string
  }
  serviceOwner?: ServiceOwner
  cachedScore: number
  riskSummaryStats?: RiskSummaryStats
  teamOwningProcess?: string
  multiSelectTags?: MultiSelectTags
}

export type RunAllTestRequest = {
  tests: string[]
}

export interface Process {
  id: string
  name: string
  shortProcessCmd: string
  characteristics: Record<string, string>
}

export enum ProcessProvenance {
  ProcessData = 'PROCESSDATA',
  Container = 'CONTAINER',
  Kubernetes = 'KUBERNETES'
}
